import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Form,
  FormGroup,
  Label,
  InputGroup,
  Input,
  InputGroupText,
  Container
} from 'reactstrap';

import { sendOTPAction, loginFailAction } from '../../redux/auth/authAction';
import { errorToaster, isAuthenticated } from '../../utils';
import { sendAnalytics } from '../../utils/analyticsUtils';
import { Navigate, Link } from 'react-router-dom';
import { COMMON_ACTION_TYPES } from '../../redux/commonActionTypes';
import config from '../../config/config';
import classes from './loginMobile.module.scss';
import TermsCondition from '../../componentsV2/ChargeMix/TermsCondition/TermsCondition';
import MetalCloud from '../../assets/images/logo/MetalCloud.png';
import handIcon from '../../../src/image/icons//handIcon.svg';
import {
  rupeeIcon,
  smileFaceIcon,
  ControlbarIcon,
  loginmoneyIcon,
  CorrectNumberIcon,
  IncorrectNumberIcon
} from '../../assets/icons/modifiedIcons';
import RenderConditionally from '../../componentsV2/RenderConditionally';
import OTPLogin from '../OTPLogin/OTPLogin';

function LoginMobile({ sendOTPAction, loading, loginFailAction }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [contact, setContact] = useState('');
  const [checked, setChecked] = useState(true);
  const [failSignUp, setFailSignUp] = useState(false);
  const [tcCheckBox, setTCcheckbBox] = useState(true);
  const [modal, setModal] = useState(false);
  const [otpLoginPage, setOtpLoginPage] = useState(true);
  const loginViewTab = [
    {
      innerHeading: 'Cost Savings',
      innerText: 'Lowest cost Charge Mix recipe mathematically possible',
      icon: rupeeIcon
    },
    {
      innerHeading: 'Ease of Access',
      innerText: 'Complete Control Over Your Raw Materials Availability.',
      icon: ControlbarIcon
    },
    {
      innerHeading: 'Investment Returns',
      innerText: 'Product That Gives Return Of Investment Within Months!',
      icon: loginmoneyIcon
    },
    {
      innerHeading: 'Feel Confident',
      innerText: 'Feel Confident About Final Chemistry.',
      icon: smileFaceIcon
    }
  ];

  const handelTC = () => {
    setModal(true);
  };

  const SubmitContactNo = e => {
    e.preventDefault();
    var contactno = `+91${contact}`;
    sendOTPAction(contactno)
      .then(response => {
        setOtpLoginPage(false);
        // ? navigate('/OTPlogin', {
        //     state: { prevPath: location.state.prevLocation }
        //   })
        // : navigate('/OTPlogin');

        const analytics_Details = {
          defaultName: 'SUBMIT_CONTACT_NO',
          defaultDetails: `Contact Number ${contact} submitted and redirect to OTPLogin Page.`
        };

        sendAnalytics(analytics_Details);
      })
      .catch(err => {
        errorToaster(err.message);
        const analytics_Details = {
          defaultName: 'SUBMIT_CONTACT_NO_ERROR',
          defaultDetails: `Error during contact submission. Error: ${err}`
        };

        sendAnalytics(analytics_Details);

        setFailSignUp(true);
        loginFailAction(contactno, COMMON_ACTION_TYPES.LOGIN_FAILED).then(() =>
          navigate('/login')
        ); //make separate action for this without dispatching API actions.
      });
  };

  if (isAuthenticated()) {
    return <Navigate to='/' />;
  }

  function handleChange(event) {
    const { value } = event.target;
    setContact(value);
    //AddAnalytics("CONTACT_NO_ADD", "Added Contact Number inside input box.");
  }

  function handleCheckBox() {
    setChecked(!checked);
  }
  // if (loading) return <AppSpinnerWrapper />;
  return (
    <div>
      <TermsCondition
        setModal={setModal}
        modal={modal}
        setTCcheckbBox={setTCcheckbBox}
      />
      <div className={classes.mc_aling}>
        <img src={MetalCloud} className={classes.MetalCloudImage} />
      </div>
      {otpLoginPage ? (
        <div className={classes.relpos}>
          <div>
            <div className={classes.tcenter}>
              <div className='welcomstyle'>
                Welcome Back!
                <img src={handIcon} className='hand-style' />
              </div>
              <h2 className='loginStyle'>Login to your account!</h2>
            </div>
            <Form autoComplete='off' onSubmit={SubmitContactNo}>
              <FormGroup>
                <Label for='MobileNumber'>
                  <div className='whatsappText'>
                    <b> Whatsapp Number</b>
                  </div>
                </Label>
                <InputGroup>
                  <InputGroupText className='Mob-start'>+91</InputGroupText>
                  <Input
                    value={contact}
                    id='mobInput'
                    placeholder='0000000000'
                    type='number'
                    inputMode="numeric"
                    maxlength='10'
                    autoFocus
                    name='mobile'
                    pattern='[1-9]{1}[0-9]{9}'
                    onChange={handleChange}
                    className='formInput'
                  />
                  <InputGroupText className='mob-end'>
                    {contact.length < 10 ? (
                      <IncorrectNumberIcon style={{ fontSize: 16 }} />
                    ) : (
                      <CorrectNumberIcon style={{ fontSize: 16 }} />
                    )}
                  </InputGroupText>
                </InputGroup>
              </FormGroup>
              <FormGroup check>
                <Label
                  check
                  size='sm'
                  className='customcheckbox'
                  style={{
                    color: 'rgba(0,0,0,0.65)',
                    paddingLeft: '5px',
                    paddingTop: '8px'
                  }}
                >
                  <Input
                    type='checkbox'
                    checked={checked}
                    onChange={handleCheckBox}
                  />
                  <div style={{ fontSize: '12px' }}>
                    Opt in for Whatsapp Notifications
                  </div>
                  <span className='checkmark'></span>
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label
                  check
                  size='sm'
                  className='customcheckbox'
                  style={{
                    color: 'rgba(0,0,0,0.65)',
                    paddingLeft: '5px',
                    paddingTop: '8px'
                  }}
                >
                  <Input
                    type='checkbox'
                    checked={tcCheckBox}
                    onChange={() => {
                      setTCcheckbBox(!tcCheckBox);
                    }}
                  />
                  <div style={{ fontSize: '12px' }}>
                    {' '}
                    Accept ours{' '}
                    <b>
                      <span
                        onClick={() => {
                          handelTC();
                        }}
                        style={{
                          color: '#217EC0',
                          textDecoration: 'underline'
                        }}
                      >
                        Terms & Condition
                      </span>
                    </b>
                  </div>
                  <span className='checkmark'></span>
                </Label>
              </FormGroup>
              <div>
                <Button
                  className='LoginBtn'
                  size='medium'
                  style={{ marginTop: '30px', fontWeight: 700 }}
                  disabled={
                    contact == '' ||
                    checked == false ||
                    contact.length < 10 ||
                    tcCheckBox == false
                      ? true
                      : false
                  }
                >
                  Send OTP
                </Button>
              </div>
            </Form>
          </div>
        </div>
      ) : (
        <OTPLogin />
      )}

      <div className={classes.loginview}>
        <div>
          <div className={classes.text}> Why MetalCloud ?</div>
          <div className={classes.aling_innerbox}>
            {' '}
            {loginViewTab.map(tab => {
              return (
                <div className={classes.innerbox}>
                  <div className={classes.bariconbg}>
                    <RenderConditionally condition={tab.icon}>
                      <tab.icon fontSize={36} />
                    </RenderConditionally>
                  </div>
                  <div className={classes.innerheading}>{tab.innerHeading}</div>
                  <div className={classes.innertext}>{tab.innerText}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className={classes.image}>
        <div>
          <div className={classes.powtext}>A Product By</div>
          <img
            src={`${config.ECOM_IMGIX_URL}nowpurchase-logo.png?auto=format&auto=compress&w=140`}
          />
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    loading: state.apiCallsInProgress > 0
  };
}
const mapDispatchToProps = {
  sendOTPAction,
  loginFailAction
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginMobile);
